import { render, staticRenderFns } from "./AmenityIcon.vue?vue&type=template&id=10b9a37c&scoped=true&"
import script from "./AmenityIcon.vue?vue&type=script&lang=ts&"
export * from "./AmenityIcon.vue?vue&type=script&lang=ts&"
import style0 from "./AmenityIcon.vue?vue&type=style&index=0&id=10b9a37c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b9a37c",
  null
  
)

export default component.exports